import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Swiper from 'react-id-swiper';
import { Styles } from "./styles/testimonialSlider.js";
import axios from "axios";
import { Constant, imageDomain } from '../helper/Constants.js';

class TestimonialSlider extends Component {
  state = {
    secTitle: "Lets See What Our Valuable Students Think About Us. Their Testimonials.",
    backgroundImage: "testimonials-bg.jpg",
    dataList: [],
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.fetchTestimonials();
  }

  fetchTestimonials = async () => {
    try {
      const url = Constant?.getUrls?.getAllTestimonials;

      if (!url) {
        console.error("Testimonial API URL not configured");
        this.setState({ loading: false });
        return;
      }

      const resp = await axios.get(url);

      if (resp?.data?.data && Array.isArray(resp.data.data)) {
        const testimonials = resp.data.data.map(item => ({
          testimonialTitle: "What Our Users Say",
          testimonialDesc: item.content || item.description || "",
          authorName: item.name || "Anonymous",
          authorTitle: item.testimonial_from || "User",
          authorImg: item.image
            ? `${imageDomain}${item.image}`
            : `${process.env.PUBLIC_URL}/assets/images/default-avatar.png`,
        }));

        this.setState({ dataList: testimonials, loading: false });
      } else {
        this.setState({ loading: false });
      }

    } catch (error) {
      console.error("Failed to fetch testimonials:", error);
      this.setState({ error: error.message || "Failed to fetch", loading: false });
    }
  };

  render() {
    const { secTitle, backgroundImage, dataList, loading } = this.state;

    const settings = {
      slidesPerView: 2,
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      spaceBetween: 30,
      pagination: {
        el: '.slider-dot.text-center',
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        576: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 2 },
      },
    };

    return (
      <Styles>
        <section
          className="testimonial-area"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${backgroundImage})`,
          }}
        >
          <Container>
            <Row>
              <Col md="12">
                <div className="sec-title text-center">
                  <h4>{secTitle}</h4>
                </div>
              </Col>

              <Col md="12" className="testimonial-slider">
                {loading ? (
                  <div className="text-center py-5 text-muted">Loading testimonials...</div>
                ) : dataList.length === 0 ? (
                  <div className="text-center py-5 text-muted">No testimonials available.</div>
                ) : (
                  <Swiper {...settings}>
                    {dataList.map((data, i) => (
                      <div className="slider-item" key={i}>
                        <div className="desc">
                          <h5>{data.testimonialTitle}</h5>
                          <p>{data.testimonialDesc}</p>
                        </div>
                        <div className="writer text-center">
                          <img
                            src={data.authorImg}
                            className="slider-image"
                            alt={data.authorName}
                            style={{
                              width: "100px",
                              height: "100px",
                            //   borderRadius: "100%",
                              objectFit: "contain",
                            //   border: "3px solid #F7931A", // optional brand accent
                              marginBottom: "10px",
                            }}
                          />
                          <h6>{data.authorName}</h6>
                          <p>{data.authorTitle.toUpperCase()}</p>
                        </div>
                      </div>
                    ))}
                  </Swiper>
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </Styles>
    );
  }
}

export default TestimonialSlider;
